import { Property } from 'csstype';
import { AnimatePresence, MotionProps, motion } from 'framer-motion';

export type CollapseProps = {
  isCollapsed?: boolean;
  keepCollapsedInDom?: boolean;
  transition?: MotionProps['transition'];
  animate?: MotionProps['animate'];
  style?: React.CSSProperties;
  overflowType?: Property.OverflowY;
};

export const Collapse: React.FC<CollapseProps> = ({
  children,
  isCollapsed,
  transition,
  keepCollapsedInDom = false,
  animate,
  overflowType = 'auto',
  ...rest
}) => {
  if (!keepCollapsedInDom) {
    return (
      <AnimatePresence initial={false}>
        {!isCollapsed && (
          <motion.div
            initial={{ height: 0, overflowY: 'hidden' }}
            animate={
              animate ?? {
                height: 'auto',
                transitionEnd: { overflowY: overflowType },
              }
            }
            exit={{ height: 0, overflowY: 'hidden' }}
            transition={transition ?? { type: 'just' }}
            {...rest}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    );
  } else {
    return (
      <motion.div
        initial={isCollapsed && { height: 0, overflowY: 'hidden', display: 'none' }}
        animate={
          isCollapsed
            ? { height: 0, overflowY: 'hidden', transitionEnd: { display: 'none' } }
            : {
                height: 'auto',
                overflowY: 'hidden',
                transitionEnd: { overflowY: overflowType },
                display: 'block',
              }
        }
        transition={transition ?? { type: 'just' }}
        {...rest}
      >
        <div>{children}</div>
      </motion.div>
    );
  }
};
